<template>
  <ExamReport
    @created="onReportCreated"
    @goRepeat="goRepeat"
    @goAnalysis="goAnalysis"
    reportType="random"
  >
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <span>随机练习</span>
        <span class="slash">/</span>
        <span class="current">答题报告</span>
      </div>
    </template>
  </ExamReport>
</template>
<script>
import ExamReport from './components/ExamReport';
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamRandomReport',
  components: {
    ExamReport,
    ExamIndexBread,
  },
  data() {
    return {
      detail: {},
    };
  },
  methods: {
    onReportCreated(detail) {
      this.detail = detail;
    },
    async goRepeat() {
      let data = await this.$http.post('/api/app/practice/report', {
        type: 5,
        report_id: this.$route.query.id,
      });
      if (data.length === 0) {
        this.$info('当前没有题目可以练习');
        return;
      }
      this.$router.push({
        name: 'ExamRandomDo',
        query: {
          id: data,
        },
      });
    },
    goAnalysis(type) {
      this.$router.push({
        name: 'ExamRandomAnalysis',
        query: {
          id: this.$route.query.id,
          type: type,
        },
      });
    },
  },
};
</script>
